import { createStore } from 'vuex';
import { user } from '@/store/modules/user';
import { project } from '@/store/modules/project';
import { target } from '@/store/modules/target';
import { skype } from '@/store/modules/skype';
import { task } from '@/store/modules/task';
import { fileConstruction } from '@/store/modules/fileConstruction';
import { weChat } from '@/store/modules/weChat';
import { browser } from '@/store/modules/browser';
import { telegram } from '@/store/modules/telegram';
import { clipboard } from '@/store/modules/clipboard';
import { cyModule } from '@/store/modules/cyModule';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    project,
    target,
    skype,
    fileConstruction,
    browser,
    task,
    weChat,
    telegram,
    clipboard,
    cyModule,
  }
})
